import { render, staticRenderFns } from "./kenmC.vue?vue&type=template&id=bddcf090&scoped=true"
import script from "./kenmC.vue?vue&type=script&lang=js"
export * from "./kenmC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bddcf090",
  null
  
)

export default component.exports